import * as React from 'react';
import { post } from 'aws-amplify/api';

import { Stack, Paper, Alert,CircularProgress, Button, 
  Backdrop, Snackbar,
  IconButton} from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en-gb';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { ScheduleContext } from './ScheduleContext';
import ClearIcon from '@mui/icons-material/Clear';

dayjs.extend(utc);

export default function ScanPlot(
  props: {
    scans: number[]
}) {
  const scheduleContext = React.useContext(ScheduleContext);
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [plot, setPlot] = React.useState<any>(null);
  const [displayConfig, setDisplayConfig] = React.useState<boolean>(true);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [openSnack, setOpenSnack] = React.useState(false);
  const [utcDate, setUTCDate] = React.useState(dayjs.utc());
  const [plotSize, setPlotSize] = React.useState(0);
  const [heightOffset, setHeightOffset] = React.useState(0);


  const ref = React.useRef<HTMLDivElement | null>(null);
  React.useEffect(() => {
    if (ref.current) {
      const width = ref.current.offsetWidth;
      const height = ref.current.offsetHeight;

      setPlotSize(width < height ? width : height);
      setHeightOffset(ref.current.offsetTop);
    }
  }, [ref.current]);

  React.useEffect(() => {
    setPlot(null);
    setDisplayConfig(true);
  }, [props.scans])

  function doPlotSources(): void {

    setOpenBackdrop(true);
    const scans = props.scans.map(i => i + 1);

    const getOperation = post({
      apiName: 'cabb',
      path: '/plot_scans',
      options: {
        headers: {'Accept': 'image/png'},
        body: {
          project: scheduleContext.projectName,
          schedule: scheduleContext.filename,
          startDateTime: utcDate.format(),
          scans: scans
        }
      }
    });
    
    getOperation.response
    .then(response => response.body.blob()
    )
    .then((blob: any) => {
      setPlot({image: 
        URL.createObjectURL(blob)
      })
      setDisplayConfig(false);
    })
    .catch((err: any) => {
      console.error('Error fetching plot data:', err);
      setErrorMessage('Error fetching plot data: ' + err.toString())
    })
    .finally(() => {
      setOpenBackdrop(false);
    });
  }

  return (
    <Stack sx={{flexGrow: 4, marginLeft: '10px'}}  ref={ref}>
      <Backdrop
        sx={
          (theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })
        }
        open={openBackdrop}
        onClick={e => setOpenBackdrop(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        role = "alert"
        aria-label = {"Alert message"}
        open={openSnack}
        autoHideDuration={6000}
        onClose={e => setOpenSnack(false)}
      >
        <Alert severity="error"> { errorMessage } </Alert>
      </Snackbar>
      {
        displayConfig
        ?
        <Paper sx={{flexGrow: 4, padding: '10px', 
          justifyContent: 'center',
          overflowY: 'scroll', display: 'flex'}}>
          <Stack spacing={3} width={'50%'} justifyContent='center'>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
              <DatePicker label="UTC Date"
                aria-label="UTC Date"
                sx={{ width: '100%' }}
                format='YYYY-MM-DD'
                value={utcDate}
                onChange={(e) => setUTCDate(e ? e : dayjs.utc())}
              />
            </LocalizationProvider>

            <Button fullWidth variant="contained"
              onClick={doPlotSources}>Plot</Button>
          </Stack>
        </Paper>
        :
        <>
          <IconButton aria-label="save" color='primary' 
            sx={{position: 'absolute', top: heightOffset, right: '5px'}} 
            onClick={e => setDisplayConfig(true)}>
            <ClearIcon />
          </IconButton>
          <Paper sx={{flexGrow: 4, display: 'flex',
            flexDirection: 'column', alignItems: 'center'
          }}>
            <figure style={{
              width: plotSize * 1.25,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'}}>
              <img src={plot.image} alt={'Targets elevation plot'}/> 
              <figcaption style={{textAlign: 'center'}}>
                  Targets elevation plot
              </figcaption>
            </figure>
          </Paper>
        </>
      }
      </Stack>
  )
}

